const amount = value => !["number", "string"].includes(typeof value) || String(value).trim() === "" || !Number.isFinite(Number(value)) ? null : Number(value);
const exact = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", minimumFractionDigits: 2, maximumFractionDigits: 2 });
const compact = new Intl.NumberFormat("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
const integers = new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 });

export function formatINRFull(value) {
  const n = amount(value);
  return n == null ? "Not available" : exact.format(Object.is(n, -0) ? 0 : n);
}

export function formatCr(value) {
  const n = amount(value);
  if (n == null) return "Not available";
  const magnitude = Math.abs(n), sign = n < 0 ? "−" : "";
  if (magnitude >= 1e7) return `${sign}₹${compact.format(magnitude / 1e7)} Cr`;
  if (magnitude >= 1e5) return `${sign}₹${compact.format(magnitude / 1e5)} lac`;
  return formatINRFull(n);
}

export const formatINR = formatCr;
export function formatNumber(value) {
  const n = amount(value);
  return n == null ? "Not available" : integers.format(n);
}
export function formatPct(value) {
  const n = amount(value);
  return n == null ? "Not available" : `${n.toFixed(2)}%`;
}